/* ============================================================
   holy-cart-drawer.js · HØLY cart drawer behavior
   ============================================================
   Scope: the statically-mounted holy-cart-drawer section
   (<cart-drawer class="holy-cart-drawer" data-holy-section="cart-drawer">).

   Wonder's cart-drawer.js (CartDrawerSection custom element) owns
   open/close, scrim, Escape and focus management. This file owns only
   what the HØLY markup adds on top of Wonder:
     · quantity +/− (data-holy-cart-qty-inc/dec → POST /cart/change.js)
     · line remove (data-holy-cart-remove → quantity 0)
     · waitlist checkout dispatch (data-holy-waitlist-checkout →
       holy:waitlist:open custom event)
     · drawer re-render from the section render API + S3 header nav
       refresh (mirrors holy-collection.js syncCart/refreshHeaderNav)

   2026-07-04 · Block 3 fix: the previous selector [data-holy-cart-drawer]
   matched nothing (the markup carries data-holy-section="cart-drawer"),
   so every handler in this file was dead — qty/remove did nothing.
   Re-scoped + trimmed: the old form/open/close intercepts are dropped
   because Wonder + holy-collection.js already own those paths.
   ============================================================ */

(function () {
  'use strict';

  var drawer = document.querySelector('cart-drawer[data-holy-section="cart-drawer"], [data-holy-cart-drawer]');
  if (!drawer) return;

  var sectionContainer = drawer.closest('[id^="shopify-section-"]');
  var sectionId = sectionContainer ? sectionContainer.id.replace('shopify-section-', '') : null;
  var busy = false;

  drawer.addEventListener('click', function (e) {
    var wl = e.target.closest('[data-holy-waitlist-checkout]');
    if (wl) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('holy:waitlist:open', {
        detail: { source: 'cart-drawer-checkout' }
      }));
      return;
    }
    var btn = e.target.closest('[data-holy-cart-qty-inc], [data-holy-cart-qty-dec], [data-holy-cart-remove]');
    if (!btn || busy) return;
    e.preventDefault();
    var key = btn.getAttribute('data-item-key');
    if (!key) return;
    var next = 0;
    if (!btn.matches('[data-holy-cart-remove]')) {
      var row = drawer.querySelector('[data-holy-cart-item][data-item-key="' + key + '"]');
      var valEl = row && row.querySelector('[data-holy-cart-qty-val]');
      var cur = valEl ? parseInt(valEl.textContent, 10) || 0 : 0;
      next = Math.max(0, cur + (btn.matches('[data-holy-cart-qty-inc]') ? 1 : -1));
    }
    changeQty(key, next);
  });

  function changeQty(key, newQty) {
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty })
    }).then(function (r) { return r.json(); })
      .then(function () { return refreshDrawer(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  function refreshDrawer() {
    if (!sectionId) return Promise.resolve();
    return fetch(window.location.pathname + '?section_id=' + sectionId, { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshInner = doc.getElementById('CartDrawer');
        var el = document.getElementById('CartDrawer');
        if (freshInner && el) el.innerHTML = freshInner.innerHTML;
        var freshWrap = doc.querySelector('cart-drawer');
        if (freshWrap) {
          var n = parseInt(freshWrap.getAttribute('data-cart-count'), 10) || 0;
          drawer.setAttribute('data-cart-count', String(n));
          drawer.classList.toggle('wt-cart--empty', n === 0);
          drawer.classList.toggle('holy-cart-drawer--empty', n === 0);
        }
        refreshHeaderNav();
      })
      .catch(function () {});
  }

  /* Re-render the S3 header nav so bag count + account→bag swap track server truth. */
  function refreshHeaderNav() {
    var bar = document.querySelector('.s3-bar');
    if (!bar) return;
    var wrap = bar.closest('[id^="shopify-section-"]');
    if (!wrap) return;
    fetch(window.location.pathname + '?section_id=' + wrap.id.replace('shopify-section-', ''), { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var freshNav = doc.querySelector('.s3-nav');
        var nav = bar.querySelector('.s3-nav');
        if (freshNav && nav) nav.innerHTML = freshNav.innerHTML;
      }).catch(function () {});
  }
})();
